import PropTypes from 'prop-types'

import { nodePropType } from '../../common/prop-types'

const dishTypePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  position: PropTypes.number.isRequired,
  isIgnored: PropTypes.bool.isRequired,
  courseType: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
  synonyms: PropTypes.arrayOf(PropTypes.string),
  imageUrl: PropTypes.string,
  iconUrl: PropTypes.string,
  processedImageUrl: PropTypes.string,
  isExcludedFromSearch: PropTypes.bool,
  isExcludedFromBrowsing: PropTypes.bool,
  node: nodePropType.isRequired,
})

dishTypePropType.defaultProps = {
  description: undefined,
  courseType: undefined,
  synonyms: [],
  imageUrl: undefined,
  iconUrl: undefined,
  processedImageUrl: undefined,
  isExcludedFromSearch: false,
  isExcludedFromBrowsing: false,
}

export default dishTypePropType
